import React, { useMemo } from 'react';
import cn from 'classnames';
import CategoryItem from './CategoryItem';
import { categoryLables } from './constants';
import { getCategories } from '@/creditflowresearch/ui/components/league/Scorecard/StandingTable/helpers';
import { useScorecardContext } from '@/creditflowresearch/application/League/Scorecard/ScorecardContext';

import styles from './categories.module.scss';

const Categories = () => {
  const { state, toggleCategoryExpansion } = useScorecardContext();
  const { data: { categories = [], type: categoryType } } = state;

  const categoryList = useMemo(
    () => getCategories(categories, toggleCategoryExpansion),
    [categories, toggleCategoryExpansion],
  );

  return (
    <div className={ styles.container } data-test="scorecardTableCategories">
      <div className={ cn(styles.wrapperLines, styles.header) } />
      <div className={ cn(styles.wrapperLines, styles.title) }>
        { categoryLables[categoryType] || '' }
      </div>
      { categoryList.map(
        ({ key, ...category }, index) => <CategoryItem key={ key } index={ index } { ...category } />,
      ) }
      <div className={ cn(styles.wrapperLines, styles.footer) }>
        Total:
      </div>
    </div>
  );
};

export default Categories;
